import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import store from './store';

import Navbar from './Components/Navbar/Navbar';
import AboutUs from './Components/AboutsUs/AboutUs';
import FAQ from './Components/FAQ\'s/FAQ';
import Contactus from './Components/ContactUs/Contactus';
import Dashboard from './Components/Dashboard/Dashboard';
import OurProcess from './Components/OurProcess/OurProcess';
import Resources from './Components/resources/Resources';
import RequestedProperties from './Components/RequestedProperties/RequestedProperties';
import Authentication from './Components/Authentication/Authentication';
import RequestProperty from './Components/RequestProperty/RequestProperty';
import KnowYourProperty from './Components/KYP/KnowYourProperty';
import LoanImportance from './Components/LoanImportance/LoanImportance';
import KYPList from './Components/KYP-List/KYPList';
import PropertyChat2 from './Components/peropertyChat2/PropertyChat2';
import SocPage from './Components/Soc/SocPage';
import Product from './Components/RazorPay';
import OurPartners from './Components/ourpartners/OurPartners';
import NetworkErrorModal from './Components/NetworkErrorModal/NetworkErrorModal';
import { ModalProvider } from './Components/ModalContext/ModalContext';
import TermsAndConditions from './Components/Authentication/TermsAndConditions';
import CertificateDownloadHandler from './Components/CertificateDownloadHandler/CertificateDownloadHandler';
import DoCityOnboardingTour from './Components/OnboardingTour/DoCityOnboardingTour';
import ProfilePage from './Components/Profile/ProfilePage';
import { GoogleOAuthProvider } from '@react-oauth/google';

const AppContent = () => {
  const location = useLocation();
  const hideNavbarRoutes = ['/LoanImportance', '/Authentication'];

  // Thin wrappers — pass the required props to form components used as pages
  const RequestPropertyPage = () => {
    const showPrev = location.state?.showPreviousData || false;
    return (
      <RequestProperty
        propertyRequestSwitch="Request Property"
        ShowPrevousData={showPrev}
        closeModal={null}
      />
    );
  };

  const KnowYourPropertyPage = () => {
    const showPrev = location.state?.showPreviousData || false;
    return (
      <KnowYourProperty
        propertyRequestSwitch="Know Your Property"
        ShowPrevousData={showPrev}
        closeModal={null}
      />
    );
  };

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/ourProcess" element={<OurProcess />} />
        <Route path="/resources" element={<Resources />} />
        {/* <Route path="/reqProperty" element={<RequestedProperties />} /> */}
        <Route path="/Authentication" element={<Authentication />} />
        <Route path="/requestProperty" element={<RequestPropertyPage />} />
        <Route path="/kyp" element={<KnowYourPropertyPage />} />
        <Route path="/LoanImportance" element={<LoanImportance />} />
        <Route path="/KYPList" element={<KYPList />} />
        <Route path="/reqProperty" element={<PropertyChat2 />} />
        <Route path="/OurPartners" element={<OurPartners />} />
        <Route path="/termsAndConditions" element={<TermsAndConditions />} />
        <Route path="/soc" element={<SocPage />} />
        <Route path="/certificate-download" element={<CertificateDownloadHandler />} />
        <Route path="/profile" element={<ProfilePage />} />
        {/* <Route path="/Product" element={<Product />} /> */}
      </Routes>
    </>
  );
};

function App() {
  const REACT_APP_GOOGLE_CLIENT_ID = "1092623445209-8h084bf4dilvvaiubhikgh77q130f0es.apps.googleusercontent.com"

  return (
    <Provider store={store}>
      <HashRouter >
        <ModalProvider>
          <DoCityOnboardingTour />

          <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>

            <AppContent />
          </GoogleOAuthProvider>

          <NetworkErrorModal />
        </ModalProvider>
      </HashRouter >
    </Provider>
  );
}

export default App;
